import type { HelpFile } from '../../types/help'
import { ScimConfigCardTestIds } from '../../../testids/ScimConfigCardTestIds'

export const scimConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ScimConfigCardTestIds.cardTitleScimConfig]: 'SCIM connector configuration — endpoint URL, credentials, and patch behavior.',
    [ScimConfigCardTestIds.btnCreateScimConfig]: null,
    [ScimConfigCardTestIds.btnEditScimConfig]: null,
    [ScimConfigCardTestIds.selectPatchStyle]: 'How the connector applies updates: full replace or RFC-7644 patch operations.',
  },
}
